import React from "react"
import { List, ListItem, Typography } from "@mui/material"
import IconButtonWithBorder from "components/StyledComponents/IconButtonWithBorder"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import Card from "components/Card/Card"
import ListWithStatus from "components/List/ListBodyWithStatus"
import { useHistory } from "react-router-dom"

function WeeklyChallengeCard({ title, triviaContestList, route }) {
  const history = useHistory()

  return (
    <Card style={{ paddingBottom: 12, height: 395 }}>
      <List>
        <ListItem sx={{ justifyContent: "space-between", padding: "0 0 16px 0" }}>
          <Typography variant="h2">{title}</Typography>
          <span onClick={() => history.push(route)}>
            <IconButtonWithBorder aria-label="Go to Trivia Analytics">
              <ArrowForwardIosIcon sx={{ color: "white", fontSize: "small" }} />
            </IconButtonWithBorder>
          </span>
        </ListItem>
        {!triviaContestList?.length ? (
          <div className="text-center mt-3">
            <Typography variant="body2regular" sx={{ opacity: 0.6 }}>
              No Records Found
            </Typography>
          </div>
        ) : (
          <ListWithStatus data={triviaContestList ?? []} />
        )}
      </List>
    </Card>
  )
}

export default WeeklyChallengeCard
